import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/label.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

const bem = new HoneyBem('label', styles);
function Label(_ref) {
  let {
    id,
    text,
    labelFor,
    extraClasses = '',
    requiredText,
    Elem = 'label'
  } = _ref;
  return /*#__PURE__*/React.createElement(Elem, {
    id: id,
    className: bem.b(false, extraClasses),
    htmlFor: labelFor
  }, text, requiredText && " (".concat(requiredText, ")"));
}
Label.displayName = 'Label';
Label.propTypes = {
  text: PropTypes.node.isRequired,
  labelFor(_ref2) {
    let {
      labelFor,
      Elem
    } = _ref2;
    if (Elem === 'legend') {
      return null;
    }
    if (typeof labelFor !== 'string' || labelFor.trim() === '') {
      return new Error('Label component as default `label` element requires a non-empty `labelFor` prop of type string.');
    }
    return null;
  },
  requiredText: PropTypes.string,
  extraClasses: PropTypes.string,
  Elem: PropTypes.oneOf(['label', 'legend'])
};
var Label$1 = Injecss(Label, styles);

export { Label, Label$1 as default };
